export const BookingEmailSubscriptions = {
  CLASS_CONFIRMATION: "class_confirmation",
  CLASS_REMINDERS: "class_reminders"
};
